/* istanbul ignore file: Directive */
'use strict';

/**
 * Consider any click in this cell as a click of the contained checkbox.
 */
customerZone.directive('checkboxCell', [function () {
    return {
        link: function (scope, elem, attrs, ctrl) {
            elem.addClass('checkbox-cell');
            elem.click(function(event){
                if (event.target.type === 'checkbox') return; //click was accurate; nothing to do.
                elem.find('input[type=checkbox]').trigger('click');
            });
        }
    };
}]);
